// extracted by mini-css-extract-plugin
module.exports = {"message":"NoArtist-message-dRdbh","buttonContainer":"NoArtist-buttonContainer-YSsjk"};